import store from "../store"
import { CONSULTING } from "../store/data/actionTypes"

export const consultingPopup = (isConsulting = null) => {
  store.dispatch({
    type: CONSULTING,
    payload: isConsulting
  })
}

export default consultingPopup